/* unplugin-vue-components disabled */import script from "./config-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./config-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./config-dialog.vue?vue&type=style&index=0&id=4cb9c546&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb9c546"]])

export default __exports__